<div class="container">
  <div class="header-container">
    <h2>User Bulk Upload</h2>
    <p class="subtitle">Upload multiple users at once using our Excel template. Download the template, fill it with user data, and upload it back.</p>
  </div>
  
  <div class="buttons_section">
    <!-- Download Template Button -->
    <button mat-raised-button (click)="downloadTemplate()" class="action-button download-button">
      <mat-icon>download</mat-icon>
      <span>Download Template</span>
    </button>

    <!-- Upload Button -->
    <button mat-raised-button class="action-button upload-button" onclick="document.getElementById('getFile').click()">
      <mat-icon>cloud_upload</mat-icon>
      <span>Upload Excel File</span>
    </button>
    
    <!-- Submit to API Button -->
    <button mat-raised-button class="action-button submit-button" (click)="submitToApi()" [disabled]="validDataSource.data.length === 0 || isSubmitting">
      <mat-icon *ngIf="!isSubmitting">send</mat-icon>
      <mat-spinner *ngIf="isSubmitting" diameter="20" color="primary"></mat-spinner>
      <span>{{ isSubmitting ? 'Submitting...' : 'Submit Users' }}</span>
    </button>
    
    <!-- Clear Button -->
    <button mat-raised-button class="action-button clear-button" (click)="clearData()" [disabled]="validDataSource.data.length === 0 && invalidDataSource.data.length === 0">
      <mat-icon>clear</mat-icon>
      <span>Clear Data</span>
    </button>
    
    <!-- Hidden File Input -->
    <input
      type="file"
      (change)="onFileChange($event)"
      accept=".xlsx"
      id="getFile"
      style="display:none"
    />
  </div>
  
  <!-- Instructions Panel -->
  <mat-card class="data-card instructions-card" *ngIf="validDataSource.data.length === 0 && invalidDataSource.data.length === 0">
    <mat-card-title>
      <mat-icon>info</mat-icon>
      How to Use Bulk Upload
    </mat-card-title>
    <mat-card-content>
      <div class="instructions-container">
        <div class="instruction-step">
          <div class="step-number">1</div>
          <div class="step-content">
            <h3>Download Template</h3>
            <p>Click the "Download Template" button to get the Excel template file</p>
          </div>
        </div>
        <div class="instruction-step">
          <div class="step-number">2</div>
          <div class="step-content">
            <h3>Fill Template</h3>
            <p>Add your user data to the template following the required format</p>
          </div>
        </div>
        <div class="instruction-step">
          <div class="step-number">3</div>
          <div class="step-content">
            <h3>Upload File</h3>
            <p>Click "Upload Excel File" and select your completed template</p>
          </div>
        </div>
        <div class="instruction-step">
          <div class="step-number">4</div>
          <div class="step-content">
            <h3>Review Data</h3>
            <p>Check the valid and invalid data tables that will appear below</p>
          </div>
        </div>
        <div class="instruction-step">
          <div class="step-number">5</div>
          <div class="step-content">
            <h3>Submit Users</h3>
            <p>Click "Submit Users" to add the valid users to the system</p>
          </div>
        </div>
      </div>
      <div class="instructions-note">
        <mat-icon color="warn">warning</mat-icon>
        <p><strong>Note:</strong> Maximum 100 records are allowed per upload. Upload accepts only Excel (.xlsx) files.</p>
      </div>
    </mat-card-content>
  </mat-card>
  
  <!-- Tables to Display Valid and Invalid Data -->
  <div class="table-section">
    <!-- Valid Data Table -->
    <mat-card class="data-card valid-data-card" *ngIf="validDataSource.data.length > 0">
      <mat-card-header>
        <mat-icon mat-card-avatar color="primary">check_circle</mat-icon>
        <mat-card-title>
          Valid Data ({{validDataSource.data.length}} records)
        </mat-card-title>
        <mat-card-subtitle>
          These records are ready to be submitted to the system
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <div class="table-wrapper">
          <mat-table [dataSource]="validDataSource" class="mat-elevation-z8">
            <ng-container
              *ngFor="let column of displayedColumns"
              [matColumnDef]="column"
            >
              <mat-header-cell *matHeaderCellDef>
                {{ column | titlecase }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element[column] }}
              </mat-cell>
            </ng-container>
  
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>
        </div>
      </mat-card-content>
    </mat-card>
  
    <!-- Invalid Data Table -->
    <mat-card class="data-card invalid-data-card" *ngIf="invalidDataSource.data.length > 0">
      <mat-card-header>
        <mat-icon mat-card-avatar color="warn">error</mat-icon>
        <mat-card-title>
          Invalid Data ({{invalidDataSource.data.length}} records)
        </mat-card-title>
        <mat-card-subtitle>
          These records have errors and cannot be processed
        </mat-card-subtitle>
        <div class="invalid-actions">
          <button mat-stroked-button (click)="downloadInvalidData(invalidDataSource.data)" class="invalid-download-btn">
            <mat-icon>file_download</mat-icon>
            <span>Download Invalid Records</span>
          </button>
        </div>
      </mat-card-header>
      <mat-card-content>
        <div class="table-wrapper">
          <mat-table [dataSource]="invalidDataSource" class="mat-elevation-z8">
            <ng-container
              *ngFor="let column of displayedColumns"
              [matColumnDef]="column"
            >
              <mat-header-cell *matHeaderCellDef>
                {{ column | titlecase }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element[column] }}
              </mat-cell>
            </ng-container>
  
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>